import { Grid, CardHeader, CardContent, Box, TextField, CircularProgress, Avatar, Button, MenuItem, Select, FormHelperText } from "@mui/material";
import { apiCategory, sportsTeamServices } from "../../services/AllServices";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import errorHandler from "../../utils/errorHandler";
import { IMAGE_BASE } from "../../utils/constants";
import LoadingButton from "@mui/lab/LoadingButton";
import CardLayout from "../../layouts/CardLayout";
import { TicketSchema } from "../../utils/Schema";
import { toast } from "react-toastify";

function AddEditSportsTeam() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [data, setData] = useState();
  const [subcategories, setSubcategories] = useState([]);
  const [Childsubcategories, setSubChildcategories] = useState([]);
  const { id } = useParams();

  const fetchTaskData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const response = await sportsTeamServices.getById({ teamId: id });
        const resData = response?.data?.data;
        setImagePreview(IMAGE_BASE + resData?.image);
        setData(resData);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    }
  }, [id]);

  const fetchCategoriesData = async (req, res) => {
    try {
      const response = await apiCategory.categorySports({ slug: "sports" });
      setSubcategories(response?.data?.data);
    } catch (error) {
      errorHandler(error);
    }
  }

  useEffect(() => {
    fetchTaskData();
    fetchCategoriesData()
  }, [fetchTaskData]);

  const formik = useFormik({
    enableReinitialize: true,
    // validationSchema: TicketSchema,
    validate: (values) => {
      const errors = {};
      if (Childsubcategories?.length > 0 && !values.subcategoryId) {
        errors.subcategoryId = "Sub category is required";
      }
      return errors;
    },

    initialValues: {
      name: data?.name || "",
      image: data?.image || "",
      status: data?.status || "active",
      description: data?.description || "",
      categoryId: data?.categoryId || "",
      subcategoryId: data?.subcategoryId || "",
    },

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();

        if (id) { formData.append("teamId", id); }
        formData.append("name", values.name);
        formData.append("imagePath", "ticket");
        formData.append("categoryId", values.categoryId);
        if (values.subcategoryId) {
          formData.append("subcategoryId", values.subcategoryId);
        }
        formData.append("description", values.description);
        formData.append("status", values.status);
        if (selectedImage && selectedImage !== data?.image) {
          formData.append("image", selectedImage);
        }

        const response = id ? await sportsTeamServices.edit(formData) : await sportsTeamServices.add(formData);

        toast.success(response?.data?.message, { toastId: "success" });
        navigate(-1);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleImageChange = (event) => {
    const file = event.currentTarget.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];

    if (selectedImage && selectedImage.name === file?.name) {
      toast.error("You cannot upload the same image again.");
      fileInputRef.current.value = "";
      return;
    }

    if (file && validTypes.includes(file.type)) {
      setImageLoading(true);
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file));
      formik.setFieldValue("image", file);
      setTimeout(() => {
        setImageLoading(false);
      }, 2000);
    } else {
      toast.error("Please upload a valid image (JPEG, PNG, or GIF).");
      fileInputRef.current.value = "";
    }
  };

  const handleSubCategoryChange = async (event) => {
    const category = event.target.value;
    formik.setFieldValue("categoryId", category);
    formik.setFieldTouched("categoryId", true);
    formik.setFieldValue("subcategoryId", "");
    setTimeout(() => formik.validateForm(), 0);
    const payload = { categoryId: category };
    try {
      const response = await apiCategory.category(payload);
      const subcategoriesData = response.data?.data || [];
      if (subcategoriesData.length === 0) {

      }
      else {
        setSubChildcategories(subcategoriesData);
      }
    } catch (error) {
      setSubChildcategories([]);
    }
  };

  useEffect(() => {

    const fetchSubCategory = async () => {
      if (data?.categoryId) {
        try {
          const payload = { categoryId: data?.categoryId };
          const response = await apiCategory.category(payload);

          const subcategoriesData = response.data?.data || [];

          setSubChildcategories(subcategoriesData);
        } catch (error) {
          setSubChildcategories([]);
          errorHandler(error);
        }
      }
    };

    fetchSubCategory();
  }, [data?.categoryId]);

  return (
    <Box>
      <CardLayout>
        <CardHeader title={`${id ? "Edit" : "Add"} Team`} />
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
              <Grid container spacing={3}>

                <Grid item xs={12} md={12}>
                  <input
                    accept="image/*"
                    type="file"
                    ref={fileInputRef}
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />

                  <Box
                    mt={2}
                    onClick={() => fileInputRef.current.click()}
                    className="upload-box"
                  >
                    {imageLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      <Avatar
                        src={imagePreview || "/path/to/default-avatar.jpg"}
                        alt="preview"
                        className="avatar"
                      />
                    )}
                  </Box>
                  {formik.touched.image && formik.errors.image ? (
                    <div className="error-msg error-category">
                      {formik.errors.image}
                    </div>
                  ) : null}

                  <Box mt={2} display="flex" justifyContent="center">
                    <Button
                      size="large"
                      type="button"
                      variant="contained"
                      onClick={() => fileInputRef.current.click()}
                    >
                      {id ? "Edit" : "Upload"} Image
                    </Button>
                  </Box>
                </Grid>


                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    label="Team Name"
                    value={formik.values.name || ""}
                    onChange={formik.handleChange}
                    name="name"
                    error={Boolean(formik.touched.name && formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    select
                    fullWidth
                    label="Category"
                    value={formik.values.categoryId}
                    onChange={handleSubCategoryChange}
                    name="categoryId"
                    error={Boolean(formik.touched.categoryId && formik.errors.categoryId)}
                    helperText={formik.touched.categoryId && formik.errors.categoryId}
                  >
                    <MenuItem value=" " disabled>Select Sub Category</MenuItem>
                    {subcategories?.map((sub, index) => (
                      <MenuItem key={index} value={sub._id}>
                        {sub.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>


                {Childsubcategories.length > 0 ?
                  <Grid item xs={12} md={12}>
                    <TextField
                      select
                      fullWidth
                      label="Sub Category"
                      value={formik.values.subcategoryId}
                      onChange={formik.handleChange}
                      name="subcategoryId"
                      error={Boolean(formik.touched.subcategoryId && formik.errors.subcategoryId)}
                      helperText={formik.touched.subcategoryId && formik.errors.subcategoryId}
                    >
                      <MenuItem value="" disabled>Select Sub Category</MenuItem>
                      {Childsubcategories?.map((sub, index) => (
                        <MenuItem key={index} value={sub._id}>
                          {sub.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  : ''}

                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={10}
                    maxRows={10}
                    label="Description"
                    onPaste={(e) => {
                      const pastedText = e.clipboardData.getData("text");
                      if (/^\d+$/.test(pastedText)) {
                        e.preventDefault();
                      }
                    }}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    name="description"
                    error={Boolean(
                      formik.touched.description && formik.errors.description
                    )}
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    labelId="status-label"
                    id="status"
                    value={formik.values.status}
                    onChange={(e) =>
                      formik.setFieldValue("status", e.target.value)
                    }
                    fullWidth
                    error={Boolean(
                      formik.touched.status && formik.errors.status
                    )}
                    displayEmpty
                    defaultValue=""
                  >

                    <MenuItem value="">Select Status</MenuItem>
                    <MenuItem value={"active"}>Active</MenuItem>
                    <MenuItem value={"inactive"}>Inactive</MenuItem>
                  </Select>
                  {formik.touched.status && formik.errors.status && (
                    <FormHelperText error>
                      {formik.errors.status}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box mt={3}>
                    <LoadingButton
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      loading={loading}
                    >
                      {id ? "Update" : "Add"} Team
                    </LoadingButton>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default AddEditSportsTeam;